<template>
  <div class="lp-child-base basic-result" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <block-fortune-result :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <div class="fortune-input-wrap">
      <span class="subtitle">＼あなたの周りの人は何タイプ？／</span>
      <h3>そまり百音のねこ風水で<br>占ってみよう</h3>
      <block-fortune-input
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :action="action"
        :method="method"
        :token="token"
        :lp-id="lpId"
        pageLabel="basicresult"
      />
    </div>
    <div class="banner-wrap">
      <block-banner
        v-if="showBanner"
        banner-pos="2"
        :ga-event-categ="`LP${lpId}basicresult-yearluck-campaign-banner`"
        :lp-id="lpId"
        class="block-banner--2"
      />
    </div>
  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import BlockFortuneResult from './blocks/BlockFortuneResult'
import BlockSnsShare from '@/utvStore/components/recommend/lp/blocks/BlockSnsShare'
import BlockFortuneInput from './blocks/BlockFortuneInput'
import BlockBanner from './blocks/BlockBannerYearLuck'


export default {
  name: 'BasicResult',
  components: {
    BlockTitle,
    BlockFortuneResult,
    BlockFortuneInput,
    BlockSnsShare,
    BlockBanner,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
    token: {
      type: String,
      default: '',
    },
    subscUrl: String,
    resultShareWords: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    previewResultList: {
      type: Array,
      default() { return [] },
    },
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post'
    }
  },
  computed:{
    resultShareUrl(){
      return !!location.href ? location.href : ''
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  .line-campaign-message {
    background: #fff;
  }
  .block-banner--1 {
    background: #fff;
    padding-top: 40px;
  }
  .block-banner--2 {
    padding-top: 0;
    padding-bottom: 60px;
    background: #FFFBE3;
  }
  .block-menu-base {
    background: #fff;
    /deep/ .tabed-menus-base {
      padding: 0;
    }
  }
  /deep/ {
    .block-title2 .block-title2__deco { left: unset; right: 0;}
    .subscr-preview-base {
      .baseButton__button {
        font-size: 16px;
      }
    }
  }
  .three-years-later {
    margin: 0 -20px;
    width: auto;
  }
}
.fortune-input-wrap {
  color: $l_col_keycolor;
  padding: 60px 0;
  background: #fcece1;
  max-width: 580px;
  margin: auto;
  .subtitle {
    display: block;
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    margin: 0 0 4px;
  }
  h3 {
    font-size: 26px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: 0px;
    text-align: center;
    margin: 0 0 24px;
  }
  /deep/ {
    .block-fortune-input {
      padding: 0 20px;
      background: transparent;

    }
  }
  & + .banner-wrap .block-banner {
    padding: 40px 0;
    background: white;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/somarimone/BasicResult.vue